export function formattingString(str: string, type?: 'withSpaces'): string {
  if (type === 'withSpaces') {
    return str.replace(/\s+/g, ' ').trim();
  }
  return str.replace(/\s+/g, '').trim();
}
